<template>
    <fieldset class="legend">
        <legend>Vsebine:</legend>
        <div class="legend-container">
            <div class="legend-item">
                <img id="legend-students" src="/images/blog/ucenci.png" title="za učence" class="legend-image" @click="setVisibility('Za učence')">
                <label for="legenda-students" :class="{'text-shadow': checkVisibility('Za učence')}">za učence</label>
            </div>
            <div class="legend-item">
                <img id="legend-parents" src="/images/blog/starsi.png" title="za starše" class="legend-image" @click="setVisibility('Za starše')">
                <label for="legend-parents" :class="{'text-shadow': checkVisibility('Za starše')}">za starše</label>
            </div>
            <div class="legend-item">
                <img id="legend-teachers" src="/images/blog/ucitelji.png" title="za učitelje" class="legend-image" @click="setVisibility('Za učitelje')">
                <label for="legend-teachers" :class="{'text-shadow': checkVisibility('Za učitelje')}">za učitelje</label>
            </div>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: ["handleVisibility", "visibility"],
        mounted() {

        },
        methods: {
            setVisibility(visibility) {
                if (this.visibility !== visibility) {
                    this.currentVisibility = visibility;
                    this.handleVisibility(visibility, this.visibility);
                }
			},
            checkVisibility(visibility) {
                return this.visibility == visibility;
            }
        }
    }
</script>

